// extracted by mini-css-extract-plugin
module.exports = {"logo":"partners_logo__VIvoj","lg":"partners_lg__b8XpV","md":"partners_md__3UcLi","mdlg":"partners_mdlg__sTUI6"};